module.exports = __webpack_public_path__ + "img/2_99.e3be533d.png";